module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAPoAAAAkCAYAAACg2CdiAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAS5JREFUeNrs3MFNAkEYgNHFeNcSOO6etAPpQKzALUE7sARLwA60A+1ATnuFDqQC/ScOyWiMYILRCe8lk11gw2GSj8mG7Izatn1tNlvGuIrRxzhvgL92l5u8j3G26eLRlqEDFTswBSB0QOiA0AGhA0IHhA4IHRA6CB0QOiB0QOiA0AGhA7sJfW5aoFqp36fPbx7m4yrGdBiGx/UHXdfN4nBp3qAKaReoSTS8+Krh9Yp+W0ae3Zg7qMasjDyJ133+Afj2Hn1i7qB6L2XofSzz42LJP7aiQ1WmZcO547R55Ek6LzeHTPfpz/n8NMaRuYPqzPMq/qFhu8DCHvA/OggdEDogdEDogNABoQNCB4QOQgf2N/SV6YJ/Zbnr0K9jjH/yxcCvumjeH1x52ObiNwEGAN9sMlcr5VDhAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/front/RAPZ2.png
// module id = b/pi
// module chunks = 0